import { Component, Input } from '@angular/core';
import { InformationTab } from '../../../../../../utils/models/layout.interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tab-induxtry',
  templateUrl: './tab-induxtry.component.html',
  styleUrls: ['./tab-induxtry.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class TabInduxtryComponent {
  @Input() icon: string;
  @Input() title = '';
  @Input() active = false;
  @Input() disabled = false;
  @Input() alert: InformationTab;
  @Input() styleTab?: any;
}
